module.exports = __webpack_public_path__ + "img/logo.91c0a63e.png";